module.exports = __webpack_public_path__ + "img/email-mismatch.57569efe.png";